import { gql } from "@apollo/client";

export const FETCH_DOCUMENT_ID_BY_REFERENCE = gql`
    query FetchDocumentIdByReference($reference: String!) {
        officialDocumentByReference(reference: $reference) {
            id
            reference
            rootContentNode {
                id
                isPromptable
            }
        }
    }
`; 